import React from 'react';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';
import { ROOT_LABEL } from 'helper/products/fileExplorer';

import './index.scss';

export default function Breadcrumbs({
  path,
  onNavigate,
}: {
  path: string[];
  onNavigate: (path: string[]) => void;
}) {
  const crumbs = [ROOT_LABEL, ...path];

  return (
    <nav className="file-explorer-breadcrumbs" aria-label="Caminho da pasta">
      {path.length > 0 && (
        <button
          type="button"
          className="file-explorer-back"
          aria-label="Voltar para a pasta anterior"
          title="Voltar"
          onClick={() => onNavigate(path.slice(0, -1))}
        >
          <ExplorerIcon name="chevronLeft" strokeWidth={2.2} />
        </button>
      )}
      <ol className="file-explorer-crumbs">
        {crumbs.map((label, i) => {
          const isCurrent = i === crumbs.length - 1;
          const key = crumbs.slice(0, i + 1).join('/');
          return (
            <li key={key} className="file-explorer-crumb">
              {i > 0 && <span className="file-explorer-crumb-sep" aria-hidden="true">/</span>}
              {isCurrent ? (
                <span className="file-explorer-crumb-current" aria-current="page">{label}</span>
              ) : (
                <button
                  type="button"
                  className="file-explorer-crumb-link"
                  onClick={() => onNavigate(path.slice(0, i))}
                >
                  {label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
